import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import strings_de from "./strings_de.json";
import strings_en from "./strings_en.json";
import strings_es from "./strings_es.json";
import strings_fr from "./strings_fr.json";
import strings_it from "./strings_it.json";
import strings_nl from "./strings_nl.json";
import strings_zh from "./strings_zh.json";

export const defaultNS = "strings";
export const resources = {
  de: { strings: strings_de },
  en: { strings: strings_en },
  es: { strings: strings_es },
  fr: { strings: strings_fr },
  it: { strings: strings_it },
  nl: { strings: strings_nl },
  zh: { strings: strings_zh },
} as const;

const initLocalization = function (language: string) {
  if (language != null) {
    language = language.replace("-", "_");
  }
  i18next.use(initReactI18next).init({
    lng: language,
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    defaultNS: defaultNS,
    resources: resources,
  });
};

export default initLocalization;
